import React, { Suspense } from "react";
import Loader from "../components/CustomComponents/Loader";

function SuspenseProvider({ children }) {
  return <Suspense fallback={<Loader />}>{children}</Suspense>;
}

export default SuspenseProvider;
